import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Dispatch } from 'redux';
import { TimelineActions } from '../../../store';
import { ApplicationState, ViewModeType } from '../../../store/types';
import CustomControls, { CustomControlsActions, CustomControlsProps } from './CustomControls';

export const mapStateToProps: MapStateToProps<CustomControlsProps, any, ApplicationState> = (state, _) => {
  return {
    ...state.timeline
  };
};

export const mapDispatchToProps: MapDispatchToProps<CustomControlsActions, any> = (dispatch: Dispatch, _) => {
  return {
    setViewModeType: (viewModeType: ViewModeType) => dispatch(TimelineActions.setViewMode(viewModeType)),
    setRange: (startDate: Date, endDate: Date) => dispatch(TimelineActions.setRange(startDate, endDate)),
    setViewModeTypeAndRange: (startDate: Date, endDate: Date, viewModeType: ViewModeType) =>
      dispatch(TimelineActions.setRangeAndViewMode(startDate, endDate, viewModeType))
  };
};

export const CustomControlsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomControls);



// WEBPACK FOOTER //
// ./src/components/navbar/customControls/CustomControlsContainer.ts